import { useState } from "react";

import { TabContext, TabPanel } from "@mui/lab";
import { Box, Button, Divider, Tab, Tabs } from "@mui/material";
import { FilterList } from "@mui/icons-material";

import { ContractorComparison } from "../components/ContractorComparison";
import { ContractorDetails } from "../components/ContractorDetails";
import { DrawerControl, FilterSideBar } from "../../../shared/components";

export const ContractorOversight = () => {

  const [currentTab, setCurrentTab] = useState("contractorComparison");
  const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
    setCurrentTab(tab);
  };

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const handleOpenFilter = () => setIsOpenFilter(true);
  const handleCloseFilter = () => setIsOpenFilter(false);

  return (
    <Box height={"100%"} display={"flex"} flexDirection={"column"} overflow={"hidden"}>
      <TabContext value={currentTab}>
        <Box display="flex" alignItems="center" alignContent="center" pr={2}>
          <Tabs value={currentTab} onChange={handleChangeTab} aria-label="Tabs" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ minHeight: "auto" }}>
            <Tab sx={{ height: "auto", minHeight: "auto" }} label={"Contractor Comparison"} value={"contractorComparison"} />
            <Tab sx={{ height: "auto", minHeight: "auto" }} label={"Contractor Details"} value={"contractorDetails"} />
          </Tabs>
          <Button
            startIcon={<FilterList />}
            variant="text"
            color="inherit"
            sx={{ marginLeft: "auto" }}
            onClick={handleOpenFilter}
          >
            FILTERS
          </Button>
        </Box>
        <Divider />
        <TabPanel value="contractorComparison" sx={{ flexGrow: 1, p: 0, overflow: "auto" }}>
          <ContractorComparison />
        </TabPanel>
        <TabPanel value="contractorDetails" sx={{ flexGrow: 1, p: 0, overflow: "auto" }}>
          <ContractorDetails />
        </TabPanel>
      </TabContext>
      <DrawerControl
        title="Filter Records"
        subTitle="Please apply following filters to refine results"
        isOpen={isOpenFilter}
        handleClose={handleCloseFilter}
      >
        <FilterSideBar onClose={handleCloseFilter} />
      </DrawerControl>
    </Box>
  );

};